import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { StatusBtn } from "../../../components/StatusBtn";
import CountdownTimer from "../../../components/countdown/CountdownTimer";
import { IEvent } from "../../../models/Event"
import { formatEventDate, getEventDateMs } from "../../../utils/event-date";

export const HomePageCmp: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <section className="hero">
            <div className="hero__bg"></div>
            <div className="container hero__content">
                {(event.status === 'registration') && <span className="hero__badge">ההרשמה בעיצומה!</span>}
                <h1 className="hero__title">{event.description}</h1>
                <ul className="hero__meta">
                    <li>
                        <FontAwesomeIcon icon={faCalendarDays} />
                        {formatEventDate(event)}
                    </li>
                    {event.location && <li>
                        <FontAwesomeIcon icon={faLocationDot} />
                        {event.location}
                    </li>}
                </ul>
                <CountdownTimer targetDate={getEventDateMs(event)} />
                <div className="hero__actions">
                    <StatusBtn event={event} className="btn-primary btn-lg" />
                    <Link className="btn btn-glass btn-lg" to={`/${event.codeName}/details`}>פרטים מלאים</Link>
                </div>
            </div>
        </section>
    )
}
